<template>
<div id="new">

</div>
</template>

<script>
import db from './firebaseinit'
export default {
  name: 'new',
  data () {
    return {
      customer: null,
      did: null,
      e911: null,
      e911address: null
    }
  },
  methods: {
    saveEmployee () {
      db.collection('inventory').new({
        customer: this.customer,
        did: this.did,
        e911: this.e911,
        e911address: this.e911address
      })
      .then(docRef => this.$router.push('/'))
        .catch(error => console.log(err))
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/New.vue